/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const create = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M16 11.2h-3.2V8h-1.6v3.2H8v1.6h3.2V16h1.6v-3.2H16z" />
	</SVG>
);

export default create;
